/**
 * SettingsPage.jsx — App Settings (MUI)
 */
import { Box, Typography } from '@mui/material';
import SettingsPanel from '../components/settings/SettingsPanel';
import { useMobile } from '../hooks/useMobile';

export default function SettingsPage() {
  const { isMobile } = useMobile();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: isMobile ? 'calc(100dvh - 84px)' : 'calc(100dvh - 8rem)', gap: 2 }}>
      <Typography variant="h5" sx={{ fontFamily: '"Bebas Neue", sans-serif', letterSpacing: 1 }}>Settings</Typography>
      <Box sx={{ flex: 1, minHeight: 0 }}><SettingsPanel /></Box>
    </Box>
  );
}
